import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    NEXT_ACTIVITY,
    ACTIVITY_LIST,
    ACTIVITY_PROPOSAL,
    CHECK_OPPORTUNITY_CLOSED_OR_DROPPED,
    VIEW_ACTIVITY,
    NEW_ACTIVITY,
    CANCEL_ACTIVITY,
    REJECT_ACTIVITY, DISTANCE_FROM_SITE, MAINTENANCE_COST, LEAD_GATE_TYPE, POST_CLOSURE, SELECTED_TAGGED_ALONG,
} from "./type";


export const activityList = (type, modelId, page=1, version = 'V1', roleId  = '') => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.activityList}?id=${modelId}&type=${type}&page=${page}&version=${version}&role_id=${roleId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ACTIVITY_LIST,
            payload: data.response.data,
        });
        return true;
    }
};

export const nextActivity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.nextActivity}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: NEXT_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const activityProposal = (opportunityId, id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.activityProposal}?id=${id}&opportunity_id=${opportunityId}`   
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ACTIVITY_PROPOSAL,
            payload: data.response.data,
        });
        return true;
    }
};

export const checkCloseOrDropped = (opportunityId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.checkCloseOrDropped}?id=${opportunityId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: CHECK_OPPORTUNITY_CLOSED_OR_DROPPED,
            payload: data.response.data,
        });
        return true;
    }
};

export const viewActivity = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.activityById}?id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: VIEW_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const newActivity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.saveNewActivity}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: NEW_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const cancelActivity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.cancelActivity}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: CANCEL_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const rejectActivity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.rejectActivity}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: REJECT_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const distanceFromSite = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.distanceFromSite}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: DISTANCE_FROM_SITE,
            payload: data.response,
        });
        return true;
    }
};

export const maintenanceCost = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.maintenanceCost}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: MAINTENANCE_COST,
            payload: data.response,
        });
        return true;
    }
};

export const getLeadGateType = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.leadGateTypes}?type_id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: LEAD_GATE_TYPE,
            payload: data.response,
        });
        return true;
    }
};

export const savePostClosure = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.postClosure}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: POST_CLOSURE,
            payload: data.response,
        });
        return true;
    }
};

export const getSelectedTaggedAlong = (account_id, opportunity_id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.selectedTaggedAlong}?account_id=${account_id}&opportunity_id=${opportunity_id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SELECTED_TAGGED_ALONG,
            payload: data.response?.data,
        });
        return true;
    }
};
